export enum ByteFormat {
	BYTE,
	KILOBYTE,
	MEGABYTE,
	GIGABYTE
}
